/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EmployeeSchedules = {
    properties: {
        employeeId: {
    type: 'number',
    isRequired: true,
},
        schedules: {
    type: 'array',
    contains: {
        type: 'Schedule',
    },
    isRequired: true,
},
    },
};